import React from "react";
import useHome from "../hooks/useHome";

// components
import Button from "../../../component/element/forms/Button";

// constants and icons
import { FaPlus } from "react-icons/fa";

// state
import SimpleTab, { TItem } from "../../../component/ui/tabs/SimpleTab";
import UsersTable from "../misc/UsersTable";
import MarketersTable from "../misc/MarketersTable";
import LawyersTable from "../misc/LawyersTable";

const User = () => {
  const [focused, setFocused] = React.useState<TItem>({
    id: "all-users",
    name: "All Users",
  });
  const [createMarketerOpen, setCreateMarketerOpen] = React.useState(false);
  const [createLawyerOpen, setCreateLawyerOpen] = React.useState(false);
  const [createUserOpen, setCreateUserOpen] = React.useState(false);
  const { page, setPage } = useHome();

  return (
    <>
      <div className="w-full flex justify-between items-center mb-6">
        <div>
          <SimpleTab
            className="font-bold"
            items={[
              { id: "all-users", name: "All Users" },
              { id: "marketers", name: "Marketers" },
              { id: "lawyers", name: "Lawyers" },
            ]}
            focused={focused}
            onClick={(item) => {
              setFocused(item);
              setPage(1);
            }}
          />
        </div>

        {(focused.id === "all-users" ||
          focused.id === "marketers" ||
          focused.id === "lawyers") && (
          <Button
            type="button"
            title={
              focused.id === "marketers"
                ? "Create Marketer"
                : focused.id === "lawyers"
                  ? "Create Lawyer"
                  : "Create User"
            }
            children={<FaPlus className="mr-2" />}
            onClick={() =>
              focused.id === "marketers"
                ? setCreateMarketerOpen(true)
                : focused.id === "lawyers"
                  ? setCreateLawyerOpen(true)
                  : setCreateUserOpen(true)
            }
            className="px-4"
          />
        )}
      </div>

      <div className="mt-4">
        {focused.id === "marketers" ? (
          <MarketersTable
            page={page}
            setPage={setPage}
            createOpen={createMarketerOpen}
            onCreateClose={() => setCreateMarketerOpen(false)}
          />
        ) : focused.id === "lawyers" ? (
          <LawyersTable
            page={page}
            setPage={setPage}
            createOpen={createLawyerOpen}
            onCreateClose={() => setCreateLawyerOpen(false)}
          />
        ) : (
          <UsersTable
            page={page}
            setPage={setPage}
            createOpen={createUserOpen}
            onCreateClose={() => setCreateUserOpen(false)}
          />
        )}
      </div>
    </>
  );
};

export default User;
